// ── 1) モーダル開閉ロジック ──────────────
(function () {
  const modal = document.getElementById('businessHoursModal');
  const overlay = modal.querySelector('.business-hours-modal__overlay');
  const closeBtn = modal.querySelector('.business-hours-modal__close');

  function openBusinessHoursModal() {
    modal.classList.add('is-active');
  }
  function closeBusinessHoursModal() {
    modal.classList.remove('is-active');
  }
  // 背景とクローズボタンで閉じる
  [overlay, closeBtn].forEach((el) => el.addEventListener('click', closeBusinessHoursModal));

  window.openBusinessHoursModal = openBusinessHoursModal;
  window.closeBusinessHoursModal = closeBusinessHoursModal;
})();

// ── 2) ボタンクリック監視 & モーダル起動 ────────
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.js-business-hours-btn');

  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      openBusinessHoursModal?.();
    });
  });
});
